import { AxiosResponse } from "axios";
import { NotificationExtension } from "../_base/extension/NotificationExtension";
import {
  HanderResponse,
  formatDateToString,
  formatFormData,
} from "../_base/helper/FunctionHelper";
import { API_ROUTE } from "../const/apiRoute";
import { api, api4 } from "../library/axios";
import { isNullOrUndefined } from "../_base/extension/StringExtension";
import { featureOption } from "../model/ProductList";
import { MessageResponse } from "../model/MessageResponse";

export const getDataListProduct = async (query: string): Promise<any> => {
  try {
    const response: AxiosResponse = await api.get(
      API_ROUTE.GET_LIST_PRODUCT + query
    );
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const getDataDetailProduct = async (query: string): Promise<any> => {
  try {
    const response: AxiosResponse = await api.get(
      API_ROUTE.GET_DETAIL_PRODUCT + query
    );
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const modifyItemFeature = async (data: featureOption): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      API_ROUTE.MODIFY_FEATURE,
      data
    );
    if (!isNullOrUndefined(response) && response?.data?.success) {
      NotificationExtension.Success("Cập nhật thành công !");
      //updateSearchItemProduct();
    } else if (response != null)
      NotificationExtension.Fails("Cập nhật thất bại !");
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const createItemProduct = async (data: any): Promise<any> => {
  try {
    const formData = new FormData();
    // Thêm dữ liệu từ dataItemCommand vào FormData
    Object.keys(data).forEach((key) => {
      if (key === "tblItemImageCommands") {
        // Xử lý tblItemImageCommands dưới dạng FormData
        const tblItemImageCommands = data[key];
        tblItemImageCommands.forEach((item: any, index: number) => {
          Object.keys(item).forEach((itemKey) => {
            const formDataKey = `tblItemImageCommands[${index}].${itemKey}`;
            if (item[itemKey]) {
              formData.append(formDataKey, item[itemKey]);
            }
          });
        });
      } else if (key === "tagItemIds") {
        const tagItemIds = data[key];
        tagItemIds.forEach((item: any, index: number) => {
          const formDataKey = `tagItemIds[${index}]`;
          if (item !== null && item !== undefined) {
            if (item instanceof Object && !(item instanceof File)) {
              formData.append(formDataKey, item.tagId);
            } else formData.append(formDataKey, item);
          }
        });
      } else if (Array.isArray(data[key])) {
        // Handle arrays
        data[key].forEach((item: any, index: any) => {
          formatFormData(item, formData, `${key}[${index}]`);
        });
      } else if (data[key] instanceof Object && !(data[key] instanceof File)) {
        // If the value is an object (but not a File), recursively flatten it
        formatFormData(data[key], formData, key);
      } else {
        if (data[key] !== null && data[key] !== undefined) {
          formData.append(key, data[key]);
        }
      }
    });
    const response: AxiosResponse = await api.post(
      API_ROUTE.CREATE_PRODUCT,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    if (!isNullOrUndefined(response) && response?.data?.success) {
      NotificationExtension.Success("Thêm sản phẩm mới thành công !");
      //updateSearchItemProduct();
    } else if (response != null)
      NotificationExtension.Fails("Thêm sản phẩm mới thất bại !");
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const deleteItemProduct = async (data: any): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      API_ROUTE.DELETE_PRODUCT,
      data
    );
    if (!isNullOrUndefined(response) && response?.data?.success) {
      NotificationExtension.Success("Xóa thành công !");
      //updateSearchItemProduct();
    } else if (response != null) NotificationExtension.Fails("Xóa thất bại !");
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const modifyItemProduct = async (data: any): Promise<any> => {
  try {
    const formData = new FormData();

    // Thêm dữ liệu từ dataItemCommand vào FormData
    Object.keys(data).forEach((key) => {
      if (key === "tblItemImageCommands") {
        // Xử lý tblItemImageCommands dưới dạng FormData
        const tblItemImageCommands = data[key];
        tblItemImageCommands.forEach((item: any, index: number) => {
          Object.keys(item).forEach((itemKey) => {
            const formDataKey = `tblItemImageCommands[${index}].${itemKey}`;
            if (itemKey === "image" && typeof item[itemKey] === "string") {
              return;
            }
            if (item[itemKey]) {
              formData.append(formDataKey, item[itemKey]);
            }
          });
        });
      } else if (key === "tagItemIds") {
        const tagItemIds = data[key];
        tagItemIds.forEach((item: any, index: number) => {
          const formDataKey = `tagItemIds[${index}]`;
          if (item !== null && item !== undefined) {
            if (item instanceof Object && !(item instanceof File)) {
              formData.append(formDataKey, item.tagId);
            } else formData.append(formDataKey, item);
          }
        });
      } else if (Array.isArray(data[key])) {
        // Handle arrays
        data[key].forEach((item: any, index: any) => {
          formatFormData(item, formData, `${key}[${index}]`);
        });
      } else if (data[key] instanceof Object && !(data[key] instanceof File)) {
        // If the value is an object (but not a File), recursively flatten it
        formatFormData(data[key], formData, key);
      } else {
        if (data[key] !== null && data[key] !== undefined) {
          formData.append(key, data[key]);
        }
      }
    });

    const response: AxiosResponse = await api.post(
      API_ROUTE.MODIFY_PRODUCT,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    if (!isNullOrUndefined(response) && response?.data?.success) {
      NotificationExtension.Success("Chỉnh sửa sản phẩm thành công !");
      //updateSearchItemProduct();
    } else if (response != null)
      NotificationExtension.Fails("Chỉnh sửa sản phẩm thất bại !");
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const modifyItemStatus = async (id: any): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      `${API_ROUTE.MODIFY_ITEM_IN_USE}${id}`
    );
    if (!isNullOrUndefined(response) && response?.data?.success) {
      NotificationExtension.Success("Cập nhật thành công !");
      //updateSearchItemProduct();
    } else if (response != null)
      NotificationExtension.Fails("Cập nhật thất bại !");
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const modifyItemOrder = async (data: any): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      API_ROUTE.MODIFY_ITEM_ORDER,
      data
    );
    if (!isNullOrUndefined(response) && response?.data?.success) {
      NotificationExtension.Success("Cập nhật thành công !");
      //updateSearchItemProduct();
    } else if (response != null)
      NotificationExtension.Fails("Cập nhật thất bại !");
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const updateSearchItemProduct = async () => {
  await api.get(API_ROUTE.REMOVE_BY_INDEX_NAME);
  await api.get(API_ROUTE.SYNC_ITEM);
};

export const getListTechnicalCommon = async (query: string): Promise<any> => {
  try {
    const response: AxiosResponse = await api.get(
      API_ROUTE.GET_LIST_TECHNICAL_COMMON + query
    );
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const createTechnicalCommon = async (data: any): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      API_ROUTE.CREATE_TECHNICAL_COMMON,
      data
    );
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const deleteTechnicalCommon = async (data: any): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      API_ROUTE.DELETE_TECHNICAL_COMMON,
      data
    );
    if (!isNullOrUndefined(response) && response?.data?.success) {
      NotificationExtension.Success("Xóa thành công !");
    } else if (response != null) NotificationExtension.Fails("Xóa thất bại !");
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const modifyTechnicalCommon = async (data: any): Promise<any> => {
  try {
    const response: AxiosResponse = await api.put(
      API_ROUTE.MODIFY_TECHNICAL_COMMON,
      data
    );
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const Updatefilexcel = async (data: any): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      API_ROUTE.UPDATE_FILEEXCEL,
      data,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    if (!isNullOrUndefined(response) && response?.data?.success) {
      NotificationExtension.Success("Cập nhật thành công !");
    } else if (response != null)
      NotificationExtension.Fails("Cập nhật thất bại !");
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

// Cập nhật thông tin sản phẩm mới

export const handleEditProductNew = async (data: any): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      API_ROUTE.UPDATE_PRODUCT_NEW,
      data
    );
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

// Hàm để cập nhật thông tin danh mục cho sản phẩm
export const handleEditProductCategoryNew = async (data: any): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      API_ROUTE.UPDATE_PRODUCT_CATEGORY_NEW,
      data
    );
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

// Hàm để cập nhật thông số kỹ thuật
export const handleEditProductTechnicalNew = async (
  data: any[]
): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      API_ROUTE.UPDATE_PRODUCT_TECHNICAL_NEW,
      data
    );
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

// Hàm để cập nhật thuộc tính sản phẩm
export const handleEditCategoryAttrNew = async (data: any[]): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      API_ROUTE.UPDATE_PRODUCT_ATTR_NEW,
      data
    );
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

// Hàm để tải ảnh lên server lưu trữ
export const uploadImage = async (data: any): Promise<any> => {
  const formData = new FormData();
  data.forEach((item: any, index: number) => {
    Object.keys(item).forEach((itemKey) => {
      const formDataKey = `${itemKey}`;
      if (itemKey === "image" && typeof item[itemKey] === "string") {
        return;
      }
      if (item[itemKey]) {
        formData.append(formDataKey, item[itemKey]);
      }
    });
  });

  try {
    const response: AxiosResponse = await api.post(
      API_ROUTE.UPLOAD_IMAGE,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    if (!isNullOrUndefined(response) && response?.data?.success) {
      NotificationExtension.Success("Thêm ảnh thành công !");
    } else if (response != null)
      NotificationExtension.Fails("Thêm ảnh thất bại !");
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

//Hàm để cập nhật ảnh sản phẩm
export const handleEditImageNew = async (data: any[]): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      API_ROUTE.UPDATE_PRODUCT_IMAGE_NEW,
      data
    );
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

// Hàm để tải ảnh lên server lưu trữ
// export const uploadImageList = async (data: any[]): Promise<any> => {
//   const formData = new FormData();
//   data.forEach((item: any, index: number) => {
//     Object.keys(item).forEach((itemKey) => {
//       const formDataKey = `${itemKey}`;
//       if (itemKey === "image" && typeof item[itemKey] === "string") {
//         return;
//       }
//       if (item[itemKey]) {
//         formData.append(formDataKey, item[itemKey]);
//       }
//     });
//   });
//   try {
//     const response: AxiosResponse = await api.post(
//       API_ROUTE.UPLOAD_LIST_IMAGE,
//       formData,
//       {
//         headers: { "Content-Type": "multipart/form-data" },
//       }
//     );
//     if (!isNullOrUndefined(response) && response?.data?.success) {
//       NotificationExtension.Success("Thêm ảnh thành công !");
//     } else if (response != null)
//       NotificationExtension.Fails("Thêm ảnh thất bại !");
//     return response.data;
//   } catch (error) {
//     HanderResponse(error);
//   }
// };

export async function uploadFile(files: Array<File>, forder?: string) {
  if (!files || files.length < 1) {
    NotificationExtension.Fails("Danh sách file rỗng !");
    return;
  }
  const formData = new FormData();
  for (let index = 0; index < files.length; index++) {
    const element = files[index];

    // Kiểm tra nếu element không phải là File
    if (!(element instanceof File)) {
      console.error("Element is not a File:", element);
      NotificationExtension.Fails("Dữ liệu không hợp lệ !");
      return;
    }

    formData.append("files", element); // Thêm file vào FormData
  }
  try {
    // const response = await api4.post<MessageResponse<Array<any>>>(
    //   "/api-sign/api/v1/Upload/files",
    //   formData,
    //   {
    //     headers: {
    //       "Content-Type": "multipart/form-data",
    //     },
    //   }
    // );
    //  const response = await api.post<MessageResponse<Array<any>>>(
    //   "https://apis-pos-dev.hacom.vn/api-sign/api/v1/Upload/files",//Lý do call cứng là vì api này chỉ có ở bản dev, dev api-sign
    //   formData,
    //   {
    //     headers: {
    //       "Content-Type": "multipart/form-data",
    //     },
    //   }
    // );
    // const uploadUrl = forder
    //   ? `/Upload/files?forder=${forder}` //truyền tham số forder để xác định thư mục lưu trữ, nếu không truyền gì thì mặc định nó sẽ vào thư mục upload ở db
    //   : `/Upload/files`;
    const newDate = formatDateToString(new Date());
    const uploadUrl = `/Upload/files?forderFile=${`cdn/web/${newDate}`}`; // đổi lại mặc định truyền vào thư mục web
    const response = await api.post<MessageResponse<Array<any>>>(
      uploadUrl,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    if (response?.data?.success === true) {
      NotificationExtension.Success("Thêm tệp tin thành công");
      return response.data;
    } else {
      NotificationExtension.Fails("Thêm tệp tin thất bại");
    }
  } catch (error) {
    console.error("Error uploading files:", error);
    NotificationExtension.Fails("Đã xảy ra lỗi khi tải lên tệp.");
  }
  return null;
}

// Hàm để cập nhật file excel sản phẩm
export const UpdatefilexcelProduct = async (data: any): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      API_ROUTE.UPDATE_FILEEXCEL_PRODUCT,
      data,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    if (!isNullOrUndefined(response) && response?.data?.success) {
      NotificationExtension.Success("Cập nhật thành công !");
    } else if (response != null)
      NotificationExtension.Fails("Cập nhật thất bại !");
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

// Hàm để cập nhật file excel sản phẩm
export const UpdatefilexcelProductPrice = async (data: any): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      API_ROUTE.UPDATE_FILEEXCEL_PRODUCT_PRICE,
      data,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    if (!isNullOrUndefined(response) && response?.data?.success) {
      NotificationExtension.Success("Cập nhật thành công !");
    } else if (response != null)
      NotificationExtension.Fails("Cập nhật thất bại !");
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

// Hàm để cập nhật file excel SEO sản phẩm
export const UpdatefilexcelProductSEO = async (data: any): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      API_ROUTE.UPDATE_FILEEXCEL_PRODUCT_SEO,
      data,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    if (!isNullOrUndefined(response) && response?.data?.success) {
      NotificationExtension.Success("Cập nhật thành công !");
    } else if (response != null)
      NotificationExtension.Fails("Cập nhật thất bại !");
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const importExcelImageItem = async (data: any): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      API_ROUTE.IMPORT_EXCEL_IMAGE_ITEM,
      data,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const getSampleImage = async (): Promise<any> => {
  try {
    const response: AxiosResponse = await api.get(API_ROUTE.GET_SAMPLE_IMAGE);
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const getDataStockPhoto = async (query: string): Promise<any> => {
  try {
    const response: AxiosResponse = await api.get(
      API_ROUTE.GET_STOCK_PHOTO + query
    );
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};
